// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { Icon } from '@ta/styleguide.icon';
import type { Direction } from './util';

import styles from './ScrollArrow.less';

type ExternalProps = {|
  direction: Direction,
  onClick: ?(SyntheticEvent<HTMLElement>) => void,
|};

type Props = {|
  ...ExternalProps,
  isRtl: boolean,
|};

const ScrollArrow = ({ direction, onClick, isRtl }: Props) => {
  let name = 'single-chevron-right';
  if (direction === 'top') {
    name = 'single-chevron-up';
  }
  if ((!isRtl && direction === 'left') || (isRtl && direction === 'right')) {
    name = 'single-chevron-left';
  } else if ((!isRtl && direction === 'right') || (isRtl && direction === 'left')) {
    name = 'single-chevron-right';
  }
  if (direction === 'bottom') {
    name = 'single-chevron-down';
  }

  return (
    <div className={styles.container} onClick={onClick}>
      <Icon name={name} className={styles.arrow} />
    </div>
  );
};

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  isRtl: state.i18n.isRtl,
}))(ScrollArrow);
